import React from 'react';
import { Modal } from 'react-bootstrap';
import { CustomButton } from '../../../_common/CustomButton/CustomButton';
import './ForbiddenAccessModal.scss';

interface ForbiddenAccessModalProps {
    show: boolean;
    onCancel: () => void;
}

const ForbiddenAccessModal = ({ show, onCancel }: ForbiddenAccessModalProps): React.ReactElement => {
    return (
        <Modal show={show} onHide={() => {}} centered className="EditLoadProgressValidationModal-Container">
            <Modal.Header className="EditLoadProgressValidationModal-Header">
                <i className="material-icons EditLoadProgressValidationModal-CloseIcon" onClick={onCancel}>
                    clear
                </i>
            </Modal.Header>
            <Modal.Body>
                <div className="MarkLoadComplete-BodyText">You do not have permission to mark a load complete.</div>
            </Modal.Body>
            <Modal.Footer className="EditLoadProgressValidationModal-Footer">
                <div className="EditLoadProgressValidationModal-ButtonContainer">
                    <CustomButton title="OK" onClick={onCancel} isBordered />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ForbiddenAccessModal;

